// Supabase client configuration
import { createClient } from '@supabase/supabase-js'

// Database connection URL - should be moved to environment variable in production
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
if (!supabaseUrl) {
  throw new Error("Missing environment variable: REACT_APP_SUPABASE_URL");
}
if (!supabaseKey) {
  throw new Error("Missing environment variable: REACT_APP_SUPABASE_ANON_KEY");
}

// Initialize Supabase client with URL and API key
// TypeScript now knows supabaseUrl and supabaseKey are strings
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase